// Utility functions for media capability detection
// Prefer feature detection, but force MOV on iOS (all iOS browsers use WebKit and WebM can render poorly).
import { isIOS, isSafari } from 'react-device-detect';

// Returns webmPath if supported, otherwise movPath
export function getPreferredVideo(webmPath, movPath) {
  // Force MOV on iOS devices regardless of reported WebM support
  if (isIOS) return movPath;
  if (isSafari) return movPath;
  return webmPath;
}
